// alert(1);
if (!customElements.get("page-hero-banner")) {
  customElements.define(
    "page-hero-banner",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        // event selector
        this.navBuyButton = document.querySelector(".suger-shift-buy-button a");
        this.benefitButton = document.querySelector(
          ".products-banefits-section .button-primary"
        );
        this.howItWorks = document.querySelector(
          ".how-it-work-section .button-primary"
        );
        this.pageBuyButton = document.querySelector(".button-buy-4");
        this.productBuyButton = document.querySelector(
          ".product-image-n-content-wrapper .product-image-n-content-button"
        );
        // Click event
        this.navBuyButton.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.benefitButton.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.howItWorks.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.pageBuyButton.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        this.productBuyButton.addEventListener(
          w3elem,
          this.onClickHandler.bind(this)
        );
        //   alert(1);
      }

      ajaxAddToCart(config) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((response) => {
            console.log(response);
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.log("Error:", error);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }

      formDataFunction() {
        const productFromData = new FormData();
        // Manually append form data
        productFromData.append("id", 32175461040164);
        productFromData.append("quantity", 3);
        productFromData.append("properties[_fgwes__notapply]", true);
        if (this.cart) {
          productFromData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          productFromData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        return productFromData;
      }

      addProductToCart() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = this.formDataFunction();
        // return false;
        this.ajaxAddToCart(config);
      }

      onClickHandler(evt) {
        // alert(1);
        evt.preventDefault();
        this.addProductToCart(evt);
      }
    }
  );
}
